// Photos from https://citizenofnowhe.re/lines-of-the-city
import React, { Component } from 'react';
import "./styles.css";
import ButtonMore from '../../../ButtonMore';
import { setPageState } from '../../../../../Store/RootStore';
import ContactUsButton from '../../../ContactUsButton';

export default class View1 extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { isShow } = this.props

    const innerClass = isShow ? 'active' : '';

    const handleMoreClick = () => {
      setPageState('2');
      setTimeout(() => {
        window.scrollTo(0, 0);
      });
    };

    return (
      <div className='View2_1' style={{zIndex: isShow ? 2 : 0}}>
        <div className={`backImageContain`}>
          <img className='backImage' src='https://focus-training.oss-accelerate.aliyuncs.com/cisc/1-1/back.png' />
          <div className='content'>
            <div onClick={handleMoreClick} className={`viewTitle animation ${innerClass}`} style={{ transform: `translateY(${isShow ? 0 : '-100'}px)`, }}>
              <div className='title' >我们是谁</div>
              <img className='imgTitle' src="https://focus-training.oss-accelerate.aliyuncs.com/cisc/whoweare/whoweare.png"></img>
            </div>
            <div className={`viewMore animation ${innerClass}`} style={{ transform: `translateY(${isShow ? 0 : '-100'}px)`, }}>{ButtonMore(handleMoreClick)}</div>
            <div className={`viewItem`}>
              <div className='viewImageItem'>
                <img className='imageItem' src="https://focus-training.oss-accelerate.aliyuncs.com/cisc/1-1/icon.png" />
              </div>
              <div className='viewRight'>
                <div className='textCHN'>
                  CISC是一家非营利型社区服务机构，专家团队包括具备多项资格和认证且经验丰富的心理咨询师，生命教练和营养师，致力于给在英留学生提供在文化适应、学业支持和身心健康等方面的心理护航。</div>
                <div className='textENG'>CISC is a not-for-profit Community Interest Company. We are proud to have a team of international experts from diverse backgrounds who are fully qualified and insured to practice an extensive range of modalities, including psychotherapy, life coaching, and nutritional therapy.</div>
              </div>
            </div>
          </div>
        </div>
        <div className='rightView'>
          {/* {ContactUsButton(false, () => {})} */}
        </div>
      </div>
    );
  }

}
